import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../utils/translations';
import Modal from '@homeaway/react-modal';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import {StayConsumer} from '../../../../context/StayContext';
import {
    deleteAttachmentOwnerWarning,
    deleteAttachmentIPMWarning,
} from '../../constants';

export class DeleteAttachmentModal extends React.Component {
    static propTypes = {
        fileName: PropTypes.string.isRequired,
        isOpen: PropTypes.bool.isRequired,
        onClose: PropTypes.func,
        onDelete: PropTypes.func,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        onClose: () => {},
        onDelete: () => {},
        translations: {},
    };

    onDeleteClick = () => {
        this.props.onClose();
        this.props.onDelete();
    };

    render() {
        const {fileName, translations} = this.props;
        const footer = [
            <Button
                key={'cancel'}
                label={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.button.cancel'
                )}
                onClick={this.props.onClose}
            />,
            <ButtonPrimary
                key={'delete'}
                label={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.button.delete'
                )}
                onClick={this.onDeleteClick}
            />,
        ];

        return (
            <span className="DeleteAttachmentModal">
                <Modal
                    footer={footer}
                    id={'delete-attachment-modal'}
                    isOpen={this.props.isOpen}
                    onClose={this.props.onClose}
                    title={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.inbox.conversation.attachment.title'
                    )}
                >
                    <StayConsumer>
                        {({stay}) => {
                            const {ownerManaged} = stay;
                            const deleteAttachmentMessageKey = ownerManaged
                                ? deleteAttachmentOwnerWarning
                                : deleteAttachmentIPMWarning;
                            return (
                                // TODO: Add test case for the below code: [SE-3625]
                                <p>
                                    {translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        deleteAttachmentMessageKey,
                                        {file: fileName}
                                    )}
                                </p>
                            );
                        }}
                    </StayConsumer>
                </Modal>
            </span>
        );
    }
}
